// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class ReminderUserSettingsRecordDataQuoteSummary {
  readonly id: string;
  readonly quoteNumber: string;
  readonly name: string | null;
  readonly expirationDate: DateTime | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.quoteNumber = data.quoteNumber === undefined ? '' : data.quoteNumber;
    this.name = data.name === undefined ? null : data.name;
    this.expirationDate = DateHelpers.ParseServerNullableDate(data.expirationDate);
  }

  static zero(): ReminderUserSettingsRecordDataQuoteSummary {
    const zeroValues: ExcludeMethodsDeep<ReminderUserSettingsRecordDataQuoteSummary> = {
      id: NIL_UUID,
      quoteNumber: '',
      name: null,
      expirationDate: null,
    };
    return new ReminderUserSettingsRecordDataQuoteSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ReminderUserSettingsRecordDataQuoteSummaryWireFormat = {
  id: string;
  quoteNumber: string;
  name: string | null;
  expirationDate: string | null;
};

type NewReminderUserSettingsRecordDataQuoteSummaryProps = PartialDeep<
  ReminderUserSettingsRecordDataQuoteSummary,
  { recurseIntoArrays: true }
>;
export const NewReminderUserSettingsRecordDataQuoteSummary: (
  props: NewReminderUserSettingsRecordDataQuoteSummaryProps,
) => ReminderUserSettingsRecordDataQuoteSummary = (props) =>
  new ReminderUserSettingsRecordDataQuoteSummary(props);

type NewReminderUserSettingsRecordDataQuoteSummaryFromWireFormatProps = PartialDeep<
  ReminderUserSettingsRecordDataQuoteSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewReminderUserSettingsRecordDataQuoteSummaryFromWireFormat: (
  props: NewReminderUserSettingsRecordDataQuoteSummaryFromWireFormatProps,
) => ReminderUserSettingsRecordDataQuoteSummary = (props) =>
  new ReminderUserSettingsRecordDataQuoteSummary(props);
